import { useQuery } from '@tanstack/react-query';
import { type AuditLogParams, adminClient } from '../lib/admin-client.js';

export const AUDIT_KEYS = {
  list: (tenantId: string, params: AuditLogParams) =>
    ['admin-audit-log', tenantId, params] as const,
};

export function useAdminAuditLog(tenantId: string, params: AuditLogParams = {}) {
  return useQuery({
    queryKey: AUDIT_KEYS.list(tenantId, params),
    queryFn: () => adminClient.queryAuditLog(tenantId, params),
    enabled: tenantId.length > 0,
    staleTime: 10_000,
  });
}
